"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBroadcastParams = void 0;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _ParamsContext = _interopRequireDefault(require("../../contexts/ParamsContext"));
var useBroadcastParams = exports.useBroadcastParams = function useBroadcastParams() {
  var paramsContext = (0, _react.useContext)(_ParamsContext["default"]);
  var routeParams = (0, _reactRouterDom.useParams)();
  var eventId;
  if (paramsContext && paramsContext.eventId) {
    eventId = paramsContext.eventId;
  } else {
    eventId = routeParams.eventId;
  }
  return eventId;
};